import React, { useEffect, useState } from "react";
import { apiPath } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";
import { useParams } from "react-router-dom";

function UniqueReviewPage() {
  const { homeApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(homeApi);
  const [filteredData, setFilteredData] = useState({});
  let { id } = useParams();

  // filter by slug
  useEffect(() => {
    setFilteredData(
      apiData.filter((item) => !item.slug).filter((item) => item._id === id)[0]
        ?.learnReview
    );
  }, [apiData]);

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  const { companyName, designation, image, name, review, _id } =
    filteredData ?? {};

  // Form data
  const data = [
    {
      elementType: "file",
      label: "Client Image",
      type: "Text",
      name: "image",
      defaultValue: { url: image },
      required: false,
      fullCol: true,
    },
    {
      elementType: "input",
      label: "Client Name",
      type: "Text",
      name: "name",
      defaultValue: name,
      required: false,
    },
    {
      elementType: "textField",
      label: "company Name",
      type: "Text",
      name: "companyName",
      defaultValue: companyName,
      required: false,
    },
    {
      elementType: "textField",
      label: "designation",
      type: "Text",
      name: "designation",
      defaultValue: designation,
      required: false,
    },
    {
      elementType: "textField",
      label: "review",
      type: "Text",
      name: "review",
      defaultValue: review,
      required: false,
    },
  ];

  const update = (data) => {
    const newData = { learnReview: data };
    updateData(homeApi, newData, id);
  };

  return <div>{name && <GlobalForm data={data} update={update} />}</div>;
}

export default UniqueReviewPage;
